// Import SASS
import '../sass/style.scss';

// Import scripts
import './modules/instagram';
import './modules/sliders';
import './modules/object-fit-images';
import './modules/skip-link-focus-fix';
import baguetteBox from 'baguettebox.js';

// Hamburger menu
document.querySelector("#nav-toggle").addEventListener("click", function () {
	this.classList.toggle("active");
	let mainNav = document.querySelector('.main-navigation');
	mainNav.classList.toggle('toggled');
});

// Navigation
const navItems = document.querySelectorAll('.header__nav .menu > li > a');
for(let i=0; i < navItems.length; i++) {
	navItems[i].addEventListener('click', function(e) {
		e.preventDefault();
		let item = navItems[i];
		item.nextElementSibling.style = "display: block;";
	});
}

baguetteBox.run('.gallery', {
	animation: 'slideIn'
});


// WEBPACK FOOTER //
// ./js/app.js